import { SortDirections } from "app/ApiClient";
import { sortString } from "./sortHelper";

export function maxStringBy<T>(collection: T[], selector: (obj: T) => string): string | undefined {
  const result = [...collection].sort((a, b) => sortString(selector(a), selector(b), SortDirections.Desceding));

  if (!result[0]) {
    return undefined;
  }

  return selector(result[0]);
}
